import { a as __assign } from './_tslib-4c7d6ae2.js';
import React__default from 'react';
import { S as SlideUpTransition } from './SlideUpTransition-6ca05452.js';
import { u as useMediaQuery } from './useMediaQuery-f31e69fd.js';
import { M as Modal } from './Modal-4b5b9d14.js';

var ResponsiveModal = function (props) {
    var isMobile = useMediaQuery("(max-width: 576px)");
    return isMobile ? (React__default.createElement(SlideUpTransition, __assign({ isVisible: props.isOpen, closeOnBackButton: false }, props))) : (React__default.createElement(Modal, __assign({}, props)));
};

export { ResponsiveModal as R };
//# sourceMappingURL=ResponsiveModal-b82c8862.js.map
